import * as React from 'react'

import { Box, Button, Spinner } from '@factorialco/deprecated-design-system'
import isEmpty from 'lodash/isEmpty'
import xor from 'lodash/xor'

import { observer } from 'mobx-react'

import Modal from 'modules/core/components/Modal'
import useAsyncAction from 'modules/core/hooks/useAsyncAction'
import { useAsyncData } from 'modules/core/hooks/useAsyncData'
import i18n from 'modules/core/lib/i18n'

import TimeoffPoliciesSelector from 'modules/timeoff/components/TimeoffPoliciesSelector'
import allowances from 'modules/timeoff/store/collections/allowances'
import timeoffPolicies from 'modules/timeoff/store/collections/timeoffPolicies/policies'

interface Props {
  onSubmit: () => void
  onClose: () => void
}

const CreateOvertimeAllowanceModal = ({ onSubmit, onClose }: Props) => {
  const [selectedIds, setSelectedIds] = React.useState<number[]>([])

  const { loading } = useAsyncData(async () => {
    await timeoffPolicies.fetch()

    await allowances.fetch({
      data: {
        by_overtime: true,
      },
    })
  }, [])

  const { running: submitting, performAction } = useAsyncAction(async () => {
    await allowances.rpc('create_overtime_allowances', {
      timeoff_policy_ids: selectedIds,
    })
    onSubmit()
  })

  const onSelectMultiple = (timeoffPolicyIds: number[]) => {
    setSelectedIds(timeoffPolicyIds)
  }
  const onSelect = (timeoffPolicyId: number | null | undefined) => {
    if (!timeoffPolicyId) return setSelectedIds([])

    setSelectedIds(xor(selectedIds, [timeoffPolicyId]))
  }

  return (
    <Modal
      illustration="document-edit"
      title={i18n.t('time_tracking.settings.overtime.compensation.timeoff.modal.title')}
      description={i18n.t('time_tracking.settings.overtime.compensation.timeoff.modal.description')}
      onClose={onClose}
      onSubmit={performAction}
      footer={
        <>
          <Button type="secondary" onClick={onClose}>
            {i18n.t('common.cancel')}
          </Button>
          <Button disabled={submitting || isEmpty(selectedIds)} onClick={performAction}>
            {i18n.t('common.create')}
          </Button>
        </>
      }
    >
      <Box gap="s16">
        {loading && <Spinner />}
        {!loading && (
          <TimeoffPoliciesSelector
            timeoffPolicies={timeoffPolicies.models}
            onSelectMultiple={onSelectMultiple}
            selectedIds={selectedIds}
            onSelect={onSelect}
          />
        )}
      </Box>
    </Modal>
  )
}

export default observer(CreateOvertimeAllowanceModal)
